import { supabase } from '../supabaseClient';

const TABLE_NAME = 'generations_game_state';

const sanitizeGameState = (gameState) => {
  if (!gameState || typeof gameState !== 'object') return {};
  // eslint-disable-next-line no-unused-vars
  const { loading, isChecking, isTransitioning, isRequestPending, isPrefetchPending, ...rest } =
    gameState;
  return rest;
};

/**
 * Returns { gameState, bufferedRound } or null if no saved state.
 */
export const getSavedGenerationsGameDb = async (userId) => {
  if (!userId) return null;
  try {
    const { data, error } = await supabase
      .from(TABLE_NAME)
      .select('state')
      .eq('user_id', userId)
      .maybeSingle();

    if (error) {
      console.error('Error reading generations game from DB:', error);
      return null;
    }

    if (!data?.state) return null;

    // Separate bufferedRound from the rest of the game state.
    const { bufferedRound, ...gameState } = data.state;
    return { gameState, bufferedRound: bufferedRound || null };
  } catch (error) {
    console.error('Unexpected error reading generations game from DB:', error);
    return null;
  }
};

export const saveGenerationsGameDb = async (userId, gameState, usedLetters, bufferedRound = null) => {
  if (!userId) return false;

  const stateToSave = {
    ...sanitizeGameState(gameState),
    usedLetters: Array.from(usedLetters || []),
    // Persist the buffer so it survives app backgrounding / tab unload.
    bufferedRound: bufferedRound || null,
  };

  try {
    const { error } = await supabase
      .from(TABLE_NAME)
      .upsert(
        {
          user_id: userId,
          state: stateToSave,
          updated_at: new Date().toISOString(),
        },
        { onConflict: 'user_id' }
      );

    if (error) {
      console.error('Error saving generations game to DB:', error);
      return false;
    }
    return true;
  } catch (error) {
    console.error('Unexpected error saving generations game to DB:', error);
    return false;
  }
};

export const clearSavedGenerationsGameDb = async (userId) => {
  if (!userId) return false;
  try {
    const { error } = await supabase.from(TABLE_NAME).delete().eq('user_id', userId);
    if (error) {
      console.error('Error clearing generations game in DB:', error);
      return false;
    }
    return true;
  } catch (error) {
    console.error('Unexpected error clearing generations game in DB:', error);
    return false;
  }
};

